import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "noobsync_amb_token";
const REFRESH_KEY = "noobsync_amb_refresh";
const USER_KEY = "noobsync_amb_user";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const getRefreshToken = () => localStorage.getItem(REFRESH_KEY);
export const setRefreshToken = (t) => t && localStorage.setItem(REFRESH_KEY, t);
export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
};

export const getUser = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};
export const setUser = (u) => localStorage.setItem(USER_KEY, JSON.stringify(u));

// Persist a full auth response ({ token, refresh_token, user }).
export const setSession = (data) => {
  if (data?.token) setToken(data.token);
  if (data?.refresh_token) setRefreshToken(data.refresh_token);
  if (data?.user) setUser(data.user);
};

// Revoke the refresh-token family server-side, then clear local storage.
export const logout = async () => {
  const rt = getRefreshToken();
  try {
    if (rt) await axios.post(`${API}/auth/logout`, { refresh_token: rt });
  } catch {
    /* best-effort */
  }
  clearToken();
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let _refreshing = null;

const _forceLogin = () => {
  clearToken();
  if (!window.location.pathname.startsWith("/login")) {
    window.location.href = "/login";
  }
};

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const original = err?.config || {};
    const status = err?.response?.status;
    const url = original?.url || "";
    const isAuthCall = /\/auth\/(login|refresh|logout|verify-otp|verify|set-password)/.test(url);

    if (status === 401 && !original._retry && !isAuthCall && getRefreshToken()) {
      original._retry = true;
      try {
        if (!_refreshing) {
          _refreshing = axios
            .post(`${API}/auth/refresh`, { refresh_token: getRefreshToken() })
            .then((res) => {
              setSession(res.data);
              return res.data.token;
            })
            .finally(() => {
              _refreshing = null;
            });
        }
        const newToken = await _refreshing;
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${newToken}`;
        return api(original);
      } catch (e) {
        _forceLogin();
        return Promise.reject(e);
      }
    }

    if (status === 401 && !isAuthCall) {
      _forceLogin();
    }
    return Promise.reject(err);
  }
);
